import React from 'react';
import ProductAdmin from './product/ProductAdmin';
import VoucherAdmin from './voucher/VoucherAdmin';
import Box from '@mui/material/Box';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Link } from 'react-router-dom';
import StatusAdmin from './status/StatusAdmin';
import FeatureAdmin from './feature/FeatureAdmin';

type NavBarMode = 'Products' | 'Vouchers' | 'Status' | 'Features';
const navBarModeValues: Record<NavBarMode, string> = {
  'Products': '/admin/products',
  'Vouchers': '/admin/vouchers',
  'Status': '/admin/status',
  'Features': '/admin/features',
};

const AdminPage = ({
  mode,
}: {
  mode: NavBarMode
}) => {
  return (
    <Box className='w-3/5 mx-auto'>
      <Tabs
        TabIndicatorProps={{ style: { background: '#ac542e' } }}
        centered
        textColor='inherit'
        className='text-accent my-8'
        value={mode}
        aria-label="Select administration mode">
        {Object.entries(navBarModeValues).map(([modeName, modeValue]) => {
          return <Tab key={modeName} value={modeName} label={modeName} component={Link} to={modeValue} />;
        })}
      </Tabs>
      {mode === 'Products' && <ProductAdmin />}
      {mode === 'Vouchers' && <VoucherAdmin />}
      {mode === 'Status' && <StatusAdmin />}
      {mode === 'Features' && <FeatureAdmin />}
    </Box >
  );
};

export default AdminPage;
